import { api } from "@/context/AuthContext";

const b64uToBuf = (s) => {
  const b64 = s.replace(/-/g, "+").replace(/_/g, "/") + "=".repeat((4 - (s.length % 4)) % 4);
  const bin = window.atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return bytes.buffer;
};

const bufToB64u = (buf) => {
  const bytes = new Uint8Array(buf);
  let bin = "";
  for (let i = 0; i < bytes.byteLength; i++) bin += String.fromCharCode(bytes[i]);
  return window.btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
};

export async function platformAuthAvailable() {
  try {
    return window.PublicKeyCredential && (await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable());
  } catch {
    return false;
  }
}

export async function webauthnRegister(identifier) {
  const { data: options } = await api.post("/webauthn/register/options", { identifier });
  options.challenge = b64uToBuf(options.challenge);
  options.user.id = b64uToBuf(options.user.id);
  if (Array.isArray(options.excludeCredentials))
    options.excludeCredentials = options.excludeCredentials.map((c) => ({ ...c, id: b64uToBuf(c.id) }));
  const cred = await navigator.credentials.create({ publicKey: options });
  if (!cred) throw new Error("cancelled");
  const r = cred.response;
  await api.post("/webauthn/register/verify", {
    identifier,
    credential: {
      id: cred.id, type: cred.type, rawId: bufToB64u(cred.rawId),
      response: { clientDataJSON: bufToB64u(r.clientDataJSON), attestationObject: bufToB64u(r.attestationObject) },
    },
  });
  return true;
}

export async function webauthnAuthenticate() {
  const { data: options } = await api.post("/webauthn/auth/options");
  options.challenge = b64uToBuf(options.challenge);
  if (Array.isArray(options.allowCredentials))
    options.allowCredentials = options.allowCredentials.map((c) => ({ ...c, id: b64uToBuf(c.id) }));
  const cred = await navigator.credentials.get({ publicKey: options });
  if (!cred) throw new Error("cancelled");
  const r = cred.response;
  await api.post("/webauthn/auth/verify", {
    credential: {
      id: cred.id, type: cred.type, rawId: bufToB64u(cred.rawId),
      response: {
        clientDataJSON: bufToB64u(r.clientDataJSON), authenticatorData: bufToB64u(r.authenticatorData),
        signature: bufToB64u(r.signature), userHandle: r.userHandle ? bufToB64u(r.userHandle) : null,
      },
    },
  });
  return true;
}
